var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20312 7.80127C3.20312 6.83477 3.98663 6.05127 4.95313 6.05127H35.2865C36.253 6.05127 37.0365 6.83477 37.0365 7.80127V49.8013C37.0365 50.7678 36.253 51.5513 35.2865 51.5513H4.95313C3.98663 51.5513 3.20312 50.7678 3.20312 49.8013V7.80127ZM6.70313 9.55127V48.0513H33.5365V9.55127H6.70313Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2865 6.05127C15.253 6.05127 16.0365 6.83477 16.0365 7.80127V49.8013C16.0365 50.7678 15.253 51.5513 14.2865 51.5513C13.32 51.5513 12.5365 50.7678 12.5365 49.8013V7.80127C12.5365 6.83477 13.32 6.05127 14.2865 6.05127Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5365 7.80127C40.5365 6.83477 41.32 6.05127 42.2865 6.05127H51.6198C52.5863 6.05127 53.3698 6.83477 53.3698 7.80127V45.1346C53.3698 45.5987 53.1854 46.0439 52.8572 46.372L48.1906 51.0387C47.5071 51.7221 46.3991 51.7221 45.7157 51.0387L41.049 46.372C40.7208 46.0439 40.5365 45.5987 40.5365 45.1346V7.80127ZM44.0365 9.55127V44.4097L46.9531 47.3264L49.8698 44.4097V9.55127H44.0365Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5365 14.8013C40.5365 13.8348 41.32 13.0513 42.2865 13.0513H51.6198C52.5863 13.0513 53.3698 13.8348 53.3698 14.8013C53.3698 15.7678 52.5863 16.5513 51.6198 16.5513H42.2865C41.32 16.5513 40.5365 15.7678 40.5365 14.8013Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20312 7.80127C3.20312 6.83477 3.98663 6.05127 4.95313 6.05127H35.2865C36.253 6.05127 37.0365 6.83477 37.0365 7.80127C37.0365 8.76777 36.253 9.55127 35.2865 9.55127H4.95313C3.98663 9.55127 3.20312 8.76777 3.20312 7.80127Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20312 49.8013C3.20312 48.8348 3.98663 48.0513 4.95313 48.0513H35.2865C36.253 48.0513 37.0365 48.8348 37.0365 49.8013C37.0365 50.7678 36.253 51.5513 35.2865 51.5513H4.95313C3.98663 51.5513 3.20312 50.7678 3.20312 49.8013Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2865 6.05127C43.253 6.05127 44.0365 6.83477 44.0365 7.80127V26.4679C44.0365 27.4344 43.253 28.2179 42.2865 28.2179C41.32 28.2179 40.5365 27.4344 40.5365 26.4679V7.80127C40.5365 6.83477 41.32 6.05127 42.2865 6.05127Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6198 6.05127C52.5863 6.05127 53.3698 6.83477 53.3698 7.80127V26.4679C53.3698 27.4344 52.5863 28.2179 51.6198 28.2179C50.6533 28.2179 49.8698 27.4344 49.8698 26.4679V7.80127C49.8698 6.83477 50.6533 6.05127 51.6198 6.05127Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.a45435c3.svg";
export { ForwardRef as ReactComponent };